import styled, { css } from 'styled-components';
import { SpaceStyledProps } from './Space.typed';
import {
  BreakpointsOptional,
  forEachBreakpoint,
  SpacingValue,
} from 'styled-system';

const getSpacePadding = (props: SpaceStyledProps) => {
  let styles = '';

  if (typeof props.space === 'string') {
    styles += `padding: calc(${props.theme.spacing[props.space]} / 2)`;
  } else {
    forEachBreakpoint((breakpoint) => {
      const space = props.space as BreakpointsOptional<SpacingValue>;
      const spaceBreakpoint = space[breakpoint] as SpacingValue;
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
          padding: calc(${props.theme.spacing[spaceBreakpoint]} / 2) 0;
        }
      `;
    });
  }

  return css`
    ${styles}
  `;
};

export const Space = styled.span<SpaceStyledProps>(({ inline }) => {
  return css`
    height: 0px;
    display: ${inline ? 'inline-block' : 'block'};
    ${getSpacePadding}
  `;
});
